import { render, staticRenderFns } from "./feedback-success.vue?vue&type=template&id=0c87ea97&"
import script from "./feedback-success.vue?vue&type=script&lang=js&"
export * from "./feedback-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports